/******************************************************************************************
 *	Remove RTM Modal
 ******************************************************************************************/
(function() {
  angular
    .module('rcControllers.removeTeamMemberModal', [])
    .factory(
      'RemoveTeamMemberModal',
      /* @ngInject */
      function(modal) {
        return modal({
          templateUrl: 'views/partials/modals/remove-team-member-modal.html',
          controller: 'RemoveTeamMemberModalController',
          classNames: 'remove-team-member-modal'
        });
      }
    )
    .controller(
      'RemoveTeamMemberModalController',
      /* @ngInject */
      function($log, $scope, RemoveTeamMemberModal, CurtainNotifications, TeamMembers) {
        //Submit
        var resetSubmit = function() {
          RemoveTeamMemberModal.unsetLoadingState();
          $scope.submitted = false;
        };

        $scope.submit = function() {
          if (!$scope.submitted) {
            $scope.submitted = true;
            RemoveTeamMemberModal.setLoadingState();

            var xhrPromise;
            //Remove the team member if it has a user ID.
            if ($scope.member.userId) {
              xhrPromise = TeamMembers.remove($scope.member.userId);
            } else if ($scope.member.inviteCode) {
              //Otherwise cancel the invitation if it has an invitation code
              xhrPromise = TeamMembers.cancelInvitation($scope.member.inviteCode);
            } else {
              CurtainNotifications.show(CurtainNotifications.ERROR, 'generic.notifications.error');
              $log.error('No UserId or InviteCode to remove from the team');
              $scope.removeModal();
              return;
            }

            if (xhrPromise) {
              xhrPromise
                .then(function(response) {
                  CurtainNotifications.show(
                    CurtainNotifications.SUCCESS,
                    'removeTeamMemberModal.notifications.submitSuccess'
                  );
                  RemoveTeamMemberModal.remove({response: $scope.member, status: response.status});
                })
                .catch(function(response) {
                  $log.error('Failed to remove the team member or cancel the invite', response.data);
                  if (response.status !== 0) {
                    //status is 0 when call is aborted
                    CurtainNotifications.show(
                      CurtainNotifications.ERROR,
                      'generic.notifications.error'
                    );
                    resetSubmit();
                  }
                });
            }
          }
        };

        //Close modal
        $scope.removeModal = function() {
          //Closing the modal via the "X" or "Cancel" buttons will resolve the promise with an object containing a true `cancelled` property
          RemoveTeamMemberModal.remove({cancelled: true});
        };
      }
    );
})();
